export class SentenceScramble {
  private elements: HTMLElement[];
  private className: string;
  private callback: Function;
  private lettersArray: string[] = [
    "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "x", "y", "z",
    "/", "-", "!", "=", "+", "\"", "~", "*", "&", "0", "1", "2", "3", "4", "5", "6", "7", "8", "9"
  ];

  public constructor(
    className: string, 
    callback: Function = () => { }, 
    isUppercase: boolean = false, 
  ) {
    this.className = className;
    this.callback = callback;
    this.elements = Array.from(document.getElementsByClassName(className)) as HTMLElement[];

    if (isUppercase) {
      // theres no "I" in here - perhaps coz it has narrow kerning?
      this.lettersArray = [
        "A", "B", "C", "D", "E", "F", "G", "H", "K", "L", "N", "O", "P", "R", "S", "T", "U", "V", "X", "Y", "Z",
        // "0", "1", "2", "3", "4", "5", "6", "7", "8", "9"
      ]
    }
  }

  /**
   * Sequentially scramble all targeted HTML elements as provided in the class constructor.
   * @param delayPerItem: Delay between each HTML element's scramble effect.
   * @param minDuration:  Minimum duration of the scramble effect per HTML element.
   * @param randomDuration: Randomized duration for the scramble effect per HTML element.
   * @param updateInterval: Interval between the letter scrambling effect on each character.
  */
  public startSequentialScramble(delayPerItem: number, minDuration: number = 1.0, randomDuration: number = 0.5, updateInterval: number = 0.05): void {
    if (this.elements.length !== 0) {
      // console.log(`${this.className} elementSize: ${this.elements.length}`)
      const scrambleDuration = Math.random() * randomDuration + minDuration;
      for (let i = 0; i < this.elements.length; i++) {
        const element = this.elements[i];
        setTimeout(() => this.sentenceReveal(element, this.lettersArray, scrambleDuration, updateInterval), i * delayPerItem * 1000);
      }
    }
    else {
      // console.warn(`Elements is empty! Populate it using classname: ${this.className}`);
    }
  }

  /**
   * Scrambles all targeted HTML elements simultaneously as provided in the class constructor.
   * @param minDuration:  Minimum duration of the scramble effect per HTML element.
   * @param randomDuration: Randomized duration for the scramble effect per HTML element.
   * @param updateInterval: Interval between the letter scrambling effect on each character.
  */
  public startScramble(minDuration: number = 1.0, randomDuration: number = 0.5, updateInterval: number = 0.05): void {
    if (this.elements.length !== 0) {
      // console.log(`${this.className} elementSize: ${this.elements.length}`)
      const scrambleDuration = Math.random() * randomDuration + minDuration;
      for (let i = 0; i < this.elements.length; i++) {
        this.sentenceReveal(this.elements[i], this.lettersArray, scrambleDuration, updateInterval)
      }
    }
    else {
      // console.warn(`Elements is empty! Populate it using classname: ${this.className}`);
    }
  }

  private isEmpty(): boolean {
    return this.elements.length === 0;
  }

  private sentenceReveal(element: HTMLElement, letters: string[], duration: number, updateInterval: number): void {
    const finalText = element.textContent;
    let startTime = Date.now();
    let lastUpdateTime = Date.now();

    const getRandomLetter = () => {
      return letters[Math.floor(Math.random() * letters.length)];
    }

    // Function to update the sentence reveal
    const updateAllChars = () => {
      const timeElapsed = Date.now() - startTime;
      const remainingTime = (duration * 1000) - timeElapsed;
      let content = "";
      if (finalText) {
        content = Array.from(finalText).map(char => char.trim() ? getRandomLetter() : char).join('');
      }

      // If the duration has passed, stop the effect and reveal the final text
      if (remainingTime <= 0) {
        element.textContent = finalText; // Reveal the final text
        element.classList.remove(this.className);
        this.elements = this.elements.filter(el => el !== element);
        if (this.isEmpty() && this.callback) {
          this.callback();
        }
        return;
      }

      // Update every frame if updateInterval is 0, otherwise update periodically based on the interval
      const now = Date.now();
      if (updateInterval === 0 || now - lastUpdateTime >= updateInterval * 1000) {
        // Update the displayed characters from the letters
        if (element.textContent) {
          // const result = element.textContent.replace(/\S/g, randomChar);
          element.textContent = content;
        }
        lastUpdateTime = now;
      }

      // Call the update function recursively for smooth animation
      requestAnimationFrame(updateAllChars);
    }

    // Start the sentence reveal process
    updateAllChars();
  }

}